import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=610cc590&scoped=true&"
import script from "./OrderInput.vue?vue&type=script&lang=js&"
export * from "./OrderInput.vue?vue&type=script&lang=js&"
import style0 from "./OrderInput.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderInput.vue?vue&type=style&index=1&id=610cc590&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cc590",
  null
  
)

export default component.exports